/**
 * 财务中心--》财务做账
 */

export default {
  show_profit_loss_statement: ['95110'], //202507071004302105709 定制 财务做账 分成利润表
  custom_acccc_detail_gridId: ['93175'], //202507211536482438339,93175网点利润表，线路利润表，隶属线路利润表 叉车费查看详情时更换gridId
  setting_default_rows_config: ['97285'], // 默认打开日记账展开的行数配置 97285 8行，其他4行
  custom_jszzf_detail_gridId: ['60233'], //202601031028299571519, 60233网点利润表，线路利润表 结算中转费查看详情时更换gridId
  custom_ccf_detail_gridId: ['73292'], //202512300909240106635, 73292 网点利润表，线路利润表 叉车费查看详情时更换gridId
  custom_zxf_detail_gridId: ['73292'], //202512300909240106635, 73292 网点利润表，线路利润表 装卸费查看详情时更换gridId
  custom_jxf_detail_gridId: ['98102']  //202603161500391438123, 98102 网点利润表，线路利润表 进仓费查看详情时更换gridId
}
  